import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const User = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M22.775 16.837C23.55 15.262 24 13.55 24 11.999C24 7.58702 20.413 3.99902 16 3.99902C11.587 3.99902 8 7.58702 8 11.999C8 13.549 8.438 15.262 9.225 16.837C6.137 18.262 4 21.387 4 25C4 26.65 5.35 28 7 28H25C26.65 28 28 26.65 28 25C28 21.387 25.863 18.262 22.775 16.837ZM16 6.00002C19.313 6.00002 22 8.68802 22 12C22 13.713 21.288 15.762 20.137 17.363C18.937 19.038 17.425 20 16 20C14.575 20 13.062 19.038 11.863 17.363C10.713 15.763 10 13.713 10 12C10 8.68702 12.688 6.00002 16 6.00002ZM25 26H7C6.45 26 6 25.55 6 25C6 22.113 7.763 19.625 10.262 18.562C11.862 20.774 13.899 22 16 22C18.101 22 20.137 20.775 21.738 18.562C24.238 19.637 26 22.112 26 25C26 25.55 25.55 26 25 26Z" />
	</svg>
);

export default User;
